module.exports = __webpack_public_path__ + "img/banner-header_00-homepage.84da5336.png";